import './YearlyTotalCard.css';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'utils/text.util';

function YearlyTotalCard({ year, total, isCardTotal = true }) {
    const { t } = useTranslation();
    let textKey = 'total_cards_for';
    if (!isCardTotal) {
        total = formatCurrency(total);
        textKey = 'transaction_total_for';
    }
    return (
        <div className="yearly-total-card">
            {`${t(textKey)} ${year}`}
            <div className="amount">
                {!isCardTotal && '$'}
                {total}
            </div>
        </div>
    );
}

export default YearlyTotalCard;
